var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-avatar',_vm._g(_vm._b({class:'elevation-' + _vm.elevation,attrs:{"color":_vm.color,"size":_vm.size}},'v-avatar',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.hint))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }